import { memo } from 'react'

interface NavLinkProps {
  href: string
  label: string
  active?: boolean
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void
  className?: string
}

export const NavLink = memo(({ href, label, active, onClick, className }: NavLinkProps) => {
  const classes = [className, active ? 'active' : ''].filter(Boolean).join(' ')
  return (
    <a href={href} onClick={onClick} className={classes}>
      {label}
    </a>
  )
})

NavLink.displayName = 'NavLink'
